export const PRODUCTS = {
  BENEFIT: 'Beneficio',
  BUSSINES: 'Corporativo',
  LUNCH: 'ALMUERZO',
  GOVERNMENT: 'Gobierno',
};
export const MAX_LENGTH_COLOR = 7;
export const CUSTOMIZATION_PRODUCT_LIMIT = 1;
